<template>
  <div :class="style.list">
    <DoctorCard
      v-for="(doctor, index) in doctors"
      :key="doctor._id"
      :doctor="doctor"
      :bufferStatus="bufferStatus"
      :isLast="index === doctors.length - 1"
      :active="doctor._id === activeDoctorId"
      @openDoctor="$emit('openDoctor', $event)"
      @toggleStatus="$emit('toggleStatus', $event)"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../DoctorsStyle.module.scss";
import DoctorCard from "./DoctorCard.vue";
import type {doctor} from "../DoctorsType";

export default defineComponent({
  name: "DoctorsList",
  components: {
    DoctorCard
  },
  emits: ["openDoctor", "toggleStatus"],
  props: {
    doctors: {
      type: Array as PropType<doctor[]>,
      default: () => []
    },
    bufferStatus: {
      type: Object as PropType<Record<string, boolean>>,
      default: () => ({})
    },
    activeDoctorId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      style
    };
  }
});
</script>
